import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { Box, Grid, Typography } from '@material-ui/core';

import { InstructionsLoc } from '../../loc/instructions';
import { loc } from '../../lib/loc';
import { H4 } from '../../components/Header';
import { useStores } from '../../hooks/use-stores';

import Loader from '../../components/Loader';
import NotFound from '../../interface/Instructions/NotFound';

const Instructions = observer(() => {
    const { InstructionsStore: store } = useStores();
    const { loader, instructions, getInstructions, clearInstructions } = store || {};

    useEffect(() => {
        getInstructions();

        return () => {
            clearInstructions();
        };
    }, [getInstructions, clearInstructions]);

    if (loader) return <Loader />;

    return (
        <>
            <H4>{loc(InstructionsLoc.title)}</H4>

            <Box mb={4}>
                <Grid container spacing={3}>
                    {instructions?.map(({ id, image, title }) => (
                        <Grid item xs={6} md={4} lg={3} key={id}>
                            <Link to={{ pathname: `/instructions/${id}`, state: { id, title } }} className="lk-category-card">
                                <div className="lk-category-card__icon">{<img src={image} alt="" />}</div>
                                <Typography variant="body2" className="lk-category-card__title">
                                    {title}
                                </Typography>
                            </Link>
                        </Grid>
                    ))}
                </Grid>
            </Box>

            <NotFound />
        </>
    );
});

export default Instructions;
